import React from "react";
import { WEATHER_COLORS, LAYOUT } from "../theme";
import WeatherRenderer from "./WeatherRenderer";
import BottomPaneRenderer from "./BottomPaneRenderer";
import StatusBar from "./StatusBar";
import ActionBar from "./ActionBar";

const GameLayout = ({
  windowDimensions,
  simulationData,
  showBottomPane,
  onPauseClick,
  onBottomClick,
  onMuteClick,
  isMuted,
  onStayClick,
  showStayButton,
}) => {
  // レイアウト関連の計算

  const statusBarHeight = showBottomPane
    ? LAYOUT.statusBarHeight
    : LAYOUT.statusBarHeightNormal;

  const actionBarHeight = showBottomPane ? LAYOUT.actionBarHeight : 0;
  const availableHeight =
    windowDimensions.height - statusBarHeight - actionBarHeight;

  const barColor = WEATHER_COLORS[simulationData.weather];
  const topPaneHeight = showBottomPane
    ? Math.floor(availableHeight * LAYOUT.topPaneRatio)
    : availableHeight;
  const bottomPaneHeight = showBottomPane ? availableHeight - topPaneHeight : 0;

  return (
    <div className="w-full h-screen bg-black overflow-hidden relative">
      <div className="w-full h-full flex flex-col">
        <div className="flex-1 flex flex-col overflow-hidden">
          <div style={{ height: `${topPaneHeight}px` }}>
            <WeatherRenderer
              data={simulationData}
              width={windowDimensions.width}
              height={topPaneHeight}
            />
          </div>
          {showBottomPane && (
            <div style={{ height: `${bottomPaneHeight}px` }}>
              <BottomPaneRenderer
                data={simulationData}
                onBottomClick={onBottomClick}
                width={windowDimensions.width}
                height={bottomPaneHeight}
                isMuted={isMuted} // ミュート状態を渡す
              />
            </div>
          )}
        </div>

        <ActionBar
          onMuteClick={onMuteClick}
          isMuted={isMuted}
          showBottomPane={showBottomPane}
          onPauseClick={onPauseClick}
          isPaused={simulationData.is_paused}
          onStayClick={onStayClick}
          showStayButton={showStayButton}
        />

        <div
          style={{ height: `${statusBarHeight}px`, flexShrink: 0 }}
          className="flex-shrink-0 bg-gray-900"
        >
          <StatusBar
            data={simulationData}
            showBottomPane={showBottomPane}
            isMuted={isMuted} // ミュート状態を渡す
            elapsedTime={simulationData.time}
          />
        </div>
      </div>

      {/* オーバーレイ  */}
      {showBottomPane && (
        <>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: `${LAYOUT.barHeight}px`,
              background: `linear-gradient(to bottom, ${barColor}, transparent)`,
              zIndex: 10,
              pointerEvents: "none",
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: `${LAYOUT.barHeight}px`,
              background: `linear-gradient(to top, ${barColor}, transparent)`,
              zIndex: 10,
              pointerEvents: "none",
            }}
          ></div>
        </>
      )}
    </div>
  );
};

export default GameLayout;
